import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';

export class HeaderUserDetails extends Component {
  handleClick = event => {
    const { mediaQueryLg, onDropdownStateToggled } = this.props;

    if (!mediaQueryLg) {
      event.preventDefault();
      onDropdownStateToggled();
    }
  };

  handleMouseLeave = () => {
    const { mediaQueryLg, onDropdownStateToggled } = this.props;

    if (mediaQueryLg) {
      this.timer = setTimeout(onDropdownStateToggled, 750);
    }
  };

  handleMouseEnter = () => {
    const { mediaQueryLg, dropdownOpen, onDropdownStateToggled } = this.props;

    clearTimeout(this.timer);

    if (mediaQueryLg && !dropdownOpen) {
      onDropdownStateToggled();
    }
  };

  render() {
    const { dropdownOpen, mediaQueryLg, avatarUrl, firstName, children } = this.props;

    return (
      <div
        className="header__dropdown"
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}>
        <div
          className={classNames('header__dropdown__target', {
            'header__dropdown__target--open': dropdownOpen,
          })}>
          <div className="header__dropdown__avatar">
            {avatarUrl ? <img src={avatarUrl} alt="user avatar" /> : <span>{(firstName || '').slice(0, 1)}</span>}
          </div>
          <Isvg className="header__dropdown__arrow svg" uniquifyIDs={false} src={require('static/img/arrow.svg')} />
        </div>
        {dropdownOpen && mediaQueryLg && children && <div className="header__dropdown__panel">{children}</div>}
      </div>
    );
  }
}

HeaderUserDetails.propTypes = {
  avatarUrl: PropTypes.string,
  children: PropTypes.node,
  dropdownOpen: PropTypes.bool,
  firstName: PropTypes.string,
  mediaQueryLg: PropTypes.bool,
  onDropdownStateToggled: PropTypes.func.isRequired,
};
